/* eslint-disable */
import React, { Component } from "react";
import {
  stripslashes,
  showAlert,
  showCustomAlert,
} from "../Helpers/SettingHelper";
import { appId, apiUrl } from "../Helpers/Config";
import cookie from "react-cookies";
import Slider from "react-slick";
var dateFormat = require("dateformat");
import axios from "axios";

/* import modules */
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Sidebar from "./Sidebar";
import PropTypes from "prop-types";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
var Parser = require("html-react-parser");
import {
  GET_CART_DETAIL,
  GET_PROMOTIONRECEIPT,
  GET_APPLYPROMOTION,
  GET_ACTIVITYCOUNT,
} from "../../actions";
import proVouchar from "../../common/images/pro-vouchar.png";
import cashVouchar from "../../common/images/cash-vouchar.png";
import bannerImage from "../../common/images/innerbanner.jpg";
import BigproVouchar from "../../common/images/big-pro-vouchar.png";
import BigcashVouchar from "../../common/images/big-cash-vouchar.png";
var qs = require("qs");
class Myvoucher extends Component {
  constructor(props) {
    super(props);
    this.state = {
      promoused: [],
      promotions: [],
      status: "",
      promo: [],
      cartItems: [],
      promodetails: [],
      cartDetails: [],
      cart_sub_total: 0,
      cartStatus: "",
      cartTriggerFlg: "No",
      order_all: 0,
      overall_orders: 0,
      voucherStatus: "Waiting",
      myVouchers: [],
      usedVouchers: [],
      productimagePath: "",
      currentDate: "",
      redirectToCart: false,
      cartTotalItmCount: 0,
      voucherQty: 1,
      currentTab: "C",
    };

    if (cookie.load("UserId") == "" || cookie.load("UserId") == undefined) {
      cookie.save("loginpopupTrigger", "login", { path: "/" });
      props.history.push("/");
    }
  }

  componentDidMount() {
    this.props.getCartDetail();
    this.getActivityCounts();
    var customerParam = "&customer_id=" + cookie.load("UserId");
    $("#dvLoading").fadeOut(2000);

    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = today.getFullYear();
    today = yyyy + "-" + mm + "-" + dd;
    this.setState({
      currentDate: today,
    });

    axios
      .get(
        apiUrl +
          "promotion_api_v2/vouchers?app_id=" +
          appId +
          "&customer_id=" +
          cookie.load("UserId")
      )
      .then((vouchers) => {
        this.setState({ voucherStatus: "Ready" });
        /* set promotion content */
        if (vouchers.data.status === "ok") {
          this.setState({
            myVouchers: vouchers.data.result_set.voucher_list,
            usedVouchers: vouchers.data.result_set.used_vouchers,
            productimagePath: vouchers.data.common.image_source,
            status: "ok",
          });
        }
      });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.voucherlist !== this.props.voucherlist) {
      if (nextProps.voucherlist[0].status === "ok") {
        this.setState({ status: nextProps.voucherlist[0].status });
        this.setState({
          promotions: nextProps.voucherlist[0].result_set.voucher_list,
        });
        this.setState({
          promoused: nextProps.voucherlist[0].result_set.used_vouchers,
        });
      }
    }
    /*activity count - end*/
  }

  /* Get Redeem Points Count History Details */
  getActivityCounts() {
    const inputKeys = ["overall_orders"];
    this.props.getActivityCount(JSON.stringify(inputKeys));
  }

  /*  get promo category details  */
  getProductIdsDet(cartItems) {
    var product_cartid = "";
    if (Object.keys(cartItems).length > 0) {
      for (var key in cartItems) {
        if (
          product_cartid !== "" &&
          cartItems[key].cart_item_product_id !== ""
        ) {
          product_cartid += ";";
        }
        product_cartid +=
          cartItems[key].cart_item_product_id +
          "|" +
          cartItems[key].cart_item_total_price +
          "|" +
          cartItems[key].cart_item_qty;
      }
    }

    return product_cartid;
  }

  applyCouponInput() {
    var promocode = $("#applyPromo").val();
    this.addToCart("top", promocode);
  }

  addToCart(voucher) {
    if (voucher !== "") {
      if (voucher.product_voucher == "f") {
        var modifier = [];
        var combo = [];
        var postObject = {};
        var price = parseFloat("0.00");
        var ImagePath = voucher.product_thumbnail;
        if (ImagePath !== "") {
          var postImagePath =
            this.state.productimagePath + voucher.product_thumbnail;
        } else {
          postImagePath = "";
        }

        var qty_voucher = this.state.voucherQty;

        var postObject = {
          app_id: appId,
          product_id: voucher.item_product_id,
          product_name: voucher.item_name,
          product_sku: voucher.item_sku,
          product_image: postImagePath,
          availability_id: cookie.load("defaultAvilablityId"),
          product_unit_price: price,
          product_qty: qty_voucher,
          product_total_price: price,
          modifiers: modifier,
          menu_set_component: combo,
          customer_id: cookie.load("UserId"),
          order_availability_id: voucher.order_availability_id,
          order_item_id: voucher.order_item_id,
          order_outlet_id: voucher.order_outlet_id,
        };

        axios
          .post(apiUrl + "cart/is_voucher_insert", qs.stringify(postObject))
          .then((res) => {
            this.setState({ status: "ok" });
            if (res.data.status === "ok") {
              this.setState({ redirectToCart: true, voucherQty: 1 });
              $(".mfp-close").trigger("click");
              this.sateValChange("cartflg", "yes");
              this.handleShowAlertFunct(
                "success",
                "Great choice! Voucher added to your cart."
              );
            } else if (res.data.status === "error") {
              $(".mfp-close").trigger("click");
              this.handleShowAlertFunct("Error", res.data.message);
            }
          });
      }

      if (voucher.product_voucher == "c") {
        var voucherQty = this.state.voucherQty;
        var modifier = [];
        var combo = [];
        var postObject = {};
        var price = parseFloat("0.00");
        postObject = {
          app_id: appId,
          product_qty: voucherQty,
          product_voucher_points: voucher.product_voucher_points,
          customer_id: cookie.load("UserId"),
          order_item_id: voucher.order_item_id,
        };

        axios
          .post(
            apiUrl + "ordersv1/add_voucher_redeem",
            qs.stringify(postObject)
          )
          .then((res) => {
            this.setState({ status: "ok" });
            if (res.data.status === "ok") {
              this.setState({ voucherQty: 1 });
              showCustomAlert("success", "Cash Voucher Points Credited.");
              this.handleShowAlertFunct(
                "success",
                "Cash Voucher Points Credited."
              );
              this.props.history.push("/rewards");
            } else if (res.data.status === "error") {
              this.handleShowAlertFunct("Error", res.data.message);
            }
          });
      }
    }
  }

  handleShowAlertFunct(header, msg) {
    var magnfPopup = $.magnificPopup.instance;
    showAlert(header, msg, magnfPopup);
    $.magnificPopup.open({
      items: {
        src: ".alert_popup",
      },
      type: "inline",
    });
  }

  /*get receipt for promotion */
  getReceipt(promotion_id, promo) {
    $("#dvLoading").fadeIn();
    this.setState({ promo: promo });
    var params = "&promotion_id=" + promotion_id;
    this.props.getPromotionReceipt(params);
  }

  promotioncheckout() {
    $.magnificPopup.close();
    const { history } = this.props;
    cookie.save("fromCkeckOutVld", "Yes", { path: "/" });
    history.push("/checkout");
  }
  /*promotion list */

  promoPopup(promoData, viewtype) {
    console.log(viewtype, "viewtypeviewtype");
    var promoImage =
      promoData.product_thumbnail !== "" && promoData.product_thumbnail !== null
        ? promoData.product_thumbnail
        : proVouchar;
    this.setState(
      { promodetails: promoData, promoImage: promoImage, viewtype: viewtype },
      function () {
        this.trgPromoPopup();
      }.bind(this)
    );
  }

  trgPromoPopup() {
    $.magnificPopup.open({
      items: {
        src: ".receipt_popup",
      },
      type: "inline",
    });
  }

  loadProductDate(date) {
    var product_date = new Date(date).toString().split(" ");
    return product_date[2] + "-" + product_date[1] + "-" + product_date[3];
  }

  loadMyVouchers() {
    var myVouchers =
      this.state.myVouchers !== undefined ? this.state.myVouchers : Array();

    if (Object.keys(myVouchers).length > 0) {
      return this.state.myVouchers.map((vouch, index) => (
        <li className="promo-earned-col" key={index}>
          <div className="voucher-promo-earned-info">
            <div className="voucher-balance-parent">
              <div className="voucher-balance">
                <span>{vouch.order_item_voucher_balance_qty}</span> X Available
              </div>
              <p className="vouchar-txt">{vouch.product_short_description}</p>
            </div>

            <div className="promo-earned-top">
              <h4 className="promo-earned-code">
                <span> {vouch.item_name}</span>
              </h4>
              <span>Expiry {this.loadProductDate(vouch.expiry_date)}</span>
            </div>
          </div>
          <div
            className="promation_btn v-promation_btn"
            id={"promo-codediv-" + index}
          >
            {this.state.currentDate > vouch.expiry_date ? (
              <a className="button promation_btn-one" href={void 0}>
                Expired{" "}
              </a>
            ) : (
              <>
                <a
                  className="button promation_btn-one"
                  onClick={this.promoPopup.bind(this, vouch, "reddem")}
                  href={void 0}
                >
                  View
                </a>
                <a
                  className="button"
                  onClick={this.promoPopup.bind(this, vouch, "reddem")}
                  href={void 0}
                >
                  Redeem
                </a>
              </>
            )}
          </div>
        </li>
      ));
    } else {
      return <div className="no-recrds-found">No records found</div>;
    }
  }

  /* Vouchers used list*/
  loadMyUsedVouchers() {
    var myVouchers =
      this.state.usedVouchers !== undefined ? this.state.usedVouchers : Array();
    if (Object.keys(myVouchers).length > 0) {
      return myVouchers.map((vouch, index) => {
        return (
          <li className="promo-earned-col" key={index}>
            <div className="voucher-balance-parent">
              <div className="voucher-balance">
                <span>
                  {vouch.order_item_voucher_qty -
                    vouch.order_item_voucher_balance_qty >
                  0
                    ? vouch.order_item_voucher_qty -
                      vouch.order_item_voucher_balance_qty
                    : vouch.order_item_voucher_qty}
                </span>{" "}
                X Redeemed
              </div>
              <p className="vouchar-txt">{vouch.product_short_description}</p>
            </div>
            <div className="voucher-promo-earned-info">
              <div className="promo-earned-top">
                <h4 className="promo-earned-code">
                  <span> {vouch.item_name}</span>
                </h4>
                {vouch.product_voucher === "c" && (
                  <span>Points: {vouch.product_voucher_points}</span>
                )}
              </div>
            </div>
            <div
              className="promation_btn v-promation_btn"
              id={"promo-codediv-" + index}
            >
              <a
                className="button promation_btn-one"
                onClick={this.promoPopup.bind(this, vouch, "used")}
                href={void 0}
              >
                View
              </a>
            </div>
          </li>
        );
      });
    } else {
      return <div className="no-recrds-found">No records found</div>;
    }
  }

  proQtyAction(indxFlg, actionFlg, maxCount) {
    var proqtyInput = this.state.voucherQty;
    proqtyInput = parseInt(proqtyInput);
    var AvailableQty = maxCount;
    if (actionFlg === "decr") {
      proqtyInput = proqtyInput > 1 ? proqtyInput - 1 : proqtyInput;
    } else {
      if (AvailableQty > proqtyInput) {
        proqtyInput = proqtyInput + 1;
      }
    }
    this.setState({ voucherQty: proqtyInput });
  }

  sateValChange = (field, value) => {
    if (field === "cartflg") {
      this.setState({ cartTriggerFlg: value });
    }
  };
  openActiveTab(currentTab) {
    this.setState({ currentTab: currentTab });
  }

  render() {
    var settingsMyAcc = {
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      initialSlide: 4,
      responsive: [
        {
          breakpoint: 1191,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
          },
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
          },
        },
      ],
    };

    return (
      <div className="myacc-main-div">
        <Header
          cartTriggerFlg={this.state.cartTriggerFlg}
          sateValChange={this.sateValChange}
        />
        <div className="common-inner-blckdiv">
          <div className="common-inner-banner">
            <img src={bannerImage} alt="" />
            <p>My Account</p>
            <span>
              My Account Dashboard allows you to view your recent activities,
              check your reward points and update account information.
            </span>
          </div>
        </div>
        <div className="innersection_wrap myadmin_wrap">
          {/* container div - start */}
          <div className="container">
            <div className="account_sec promotion-newdesign">
              <Sidebar pageName="voucher" />
              <div className="accsec_right">
                <div className="mainacc_menucontent">
                  <div className="main_tabsec">
                    <div className="order-tab-section">
                      <div className="mainacc_mobrow">
                        <div className="tab_sec main_tabsec_inner">
                          <div className="myacc_filter">
                            <div className="tab_sec filter_tabsec">
                              <ul className="nav nav-tabs text-center">
                                <li
                                  className={
                                    this.state.currentTab === "C"
                                      ? "active"
                                      : ""
                                  }
                                >
                                  <a
                                    data-toggle="tab"
                                    href={void 0}
                                    onClick={this.openActiveTab.bind(this, "C")}
                                    aria-expanded="true"
                                  >
                                    <span>Available E-Vouchers</span>
                                  </a>
                                </li>
                                <li
                                  className={
                                    this.state.currentTab === "P"
                                      ? "active"
                                      : ""
                                  }
                                >
                                  <a
                                    data-toggle="tab"
                                    href={void 0}
                                    onClick={this.openActiveTab.bind(this, "P")}
                                    aria-expanded="false"
                                  >
                                    <span>Used E-Vouchers</span>
                                  </a>
                                </li>
                              </ul>
                              <div className="tab-content">
                                {this.state.currentTab === "C" && (
                                  <div
                                    id="tab-id-inn5"
                                    className="tab-pane fade active in"
                                  >
                                    <h4 className="tab_mobtrigger inner_tab_border active">
                                      Promotions<i></i>
                                    </h4>
                                    <div className="tab_mobrow filter_tabin">
                                      <div className="order-delivery">
                                        <div className="ord-body">
                                          <div className="cur-order-body mypromo-main-div myvouchar-main-div">
                                            <ul className="myacc_order_details">
                                              {this.loadMyVouchers(
                                                this,
                                                "vouchers"
                                              )}
                                            </ul>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                {this.state.currentTab === "P" && (
                                  <div
                                    id="tab-id-inn6"
                                    className="tab-pane fade active in"
                                  >
                                    <h4 className="tab_mobtrigger inner_tab_border active">
                                      Promotions Used<i></i>
                                    </h4>
                                    <div className="tab_mobrow filter_tabin">
                                      <div className="cur-order-body mypromo-main-div myvouchar-main-div">
                                        <ul className="myacc_order_details">
                                          {this.loadMyUsedVouchers(
                                            this,
                                            "vouchers"
                                          )}
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* container div - end */}
        </div>

        <Footer />
        <div
          id="receipt-popup"
          className="white-popup mfp-hide popup_sec receipt_popup redeem_popsec vouchar-popup"
        >
          {Object.keys(this.state.promodetails).length > 0 && (
            <div className="redeem_bansec">
              {console.log(
                this.state.promodetails,
                this.state.viewtype,
                "this.state.promodetails"
              )}
              <div className="promo-popup-image">
                {this.state.promodetails.product_thumbnail !== "" &&
                this.state.promodetails.product_thumbnail !== null ? (
                  <img
                    src={
                      this.state.productimagePath +
                      this.state.promodetails.product_thumbnail
                    }
                  />
                ) : (
                  <img
                    src={
                      this.state.promodetails.product_voucher == "c"
                        ? BigcashVouchar
                        : BigproVouchar
                    }
                  />
                )}
              </div>
              {this.state.viewtype}
              <div className="promo-earned-content">
                <h3 className="">{this.state.promodetails.item_name}</h3>
                <span className="expiry-date">
                  {this.loadProductDate(this.state.promodetails.expiry_date)}
                </span>
                {this.state.viewtype === "reddem" ? (
                  <h4>
                    Available :{" "}
                    {this.state.promodetails.order_item_voucher_balance_qty}
                  </h4>
                ) : (
                  <h4>
                    Redeemed :{" "}
                    {this.state.voucherQty -
                      this.state.promodetails.order_item_voucher_balance_qty >
                    0
                      ? this.state.voucherQty -
                        this.state.promodetails.order_item_voucher_balance_qty
                      : this.state.promodetails.order_item_voucher_balance_qty}
                  </h4>
                )}
                {this.state.promodetails.product_short_description !== "" && (
                  <p>
                    {Parser(
                      stripslashes(
                        this.state.promodetails.product_short_description + ""
                      )
                    )}
                  </p>
                )}
                {this.state.viewtype === "reddem" && (
                  <>
                    <div className="addcart_row">
                      <p className="sel-quality">Select Quantity</p>
                      <div className="addcart-row-child">
                        <div className="qty_bx">
                          <span
                            className="qty_minus"
                            onClick={this.proQtyAction.bind(
                              this,
                              this.state.promodetails.promotion_id,
                              "decr",
                              this.state.promodetails
                                .order_item_voucher_balance_qty
                            )}
                          >
                            -
                          </span>
                          <input
                            type="text"
                            className="proqty_input"
                            readOnly
                            value={this.state.voucherQty}
                          />
                          <span
                            className="qty_plus"
                            onClick={this.proQtyAction.bind(
                              this,
                              this.state.promodetails.promotion_id,
                              "incr",
                              this.state.promodetails
                                .order_item_voucher_balance_qty
                            )}
                          >
                            +
                          </span>
                        </div>
                      </div>
                    </div>

                    <a
                      className="btn btn_black btn-block"
                      onClick={this.addToCart.bind(
                        this,
                        this.state.promodetails
                      )}
                      href="javascript:void(0);"
                    >
                      Redeem Now
                    </a>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
        <div id="dvLoading"></div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  var overAllcart = Array();
  var cartTotalItmCount = 0;
  if (Object.keys(state.cartlistdetail).length > 0) {
    var resultSetArr = !("result_set" in state.cartlistdetail[0])
      ? Array()
      : state.cartlistdetail[0].result_set;
    if (
      state.cartlistdetail[0].status === "ok" &&
      Object.keys(resultSetArr).length > 0
    ) {
      overAllcart = resultSetArr;
      cartTotalItmCount = resultSetArr.cart_details.cart_total_items;
    }
  }

  return {
    activitycount: state.activitycount,
    voucherlist: state.voucherlist,
    overAllcart: overAllcart,
    cartTotalItmCount: cartTotalItmCount,
    promotionreceipt: state.promotionreceipt,
    applypromotion: state.applypromotion,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getActivityCount: (getObject) => {
      dispatch({ type: GET_ACTIVITYCOUNT, getObject });
    },
    getCartDetail: () => {
      dispatch({ type: GET_CART_DETAIL });
    },
    getPromotionReceipt: (params) => {
      dispatch({ type: GET_PROMOTIONRECEIPT, params });
    },
    getApplyPromotion: (postData) => {
      dispatch({ type: GET_APPLYPROMOTION, postData });
    },
  };
};

Myvoucher.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Myvoucher)
);
